import { useContext, useState } from 'react';
import FieldContext from '../../FieldContext';
import useCurrentFieldRef from '../../useCurrentFieldRef';
import defaultColors from 'components/ChallengePortfolio/NormalView/Challenge/ChallengeView/ChallengeFields/FieldRenderer/TypeSpecificFieldRenderers/ColorPicker/PickerContent/defaultColors';
import Space from 'lib/components/Space';
import { Button } from '@material-ui/core';
import ColorsManagerDialog from './ColorsManagerDialog';
import Dialog from 'lib/components/Dialog';
import ColorsManager from './ColorsManager';
import { FormattedMessage } from 'react-intl';

const ColorsEditor = props => {
  const { field } = useContext(FieldContext);
  const fieldRef = useCurrentFieldRef();

  const [colors, setColors] = useState(field.colors || defaultColors);
  const [colorsEditorDialogOpen, setColorsEditorDialogOpen] = useState(false);

  const colorsAreDefaultColors =
    JSON.stringify(colors) === JSON.stringify(defaultColors);

  const colorsHaveChanged =
    JSON.stringify(colors) !== JSON.stringify(field.colors || defaultColors);

  const handleResetToDefaultColors = () => {
    fieldRef.child('colors').remove();

    setColors(defaultColors);
  };

  const handleSave = () => {
    fieldRef.child('colors').set(colors);

    setColorsEditorDialogOpen(false);
  };

  return (
    <>
      <Space height={12} />
      <Button
        size="small"
        variant="outlined"
        onClick={() => setColorsEditorDialogOpen(true)}
        fullWidth
        {...props}
      >
        <FormattedMessage id="editor.model_editor.field_editor.colors_editor.button" />
      </Button>
      <ColorsManagerDialog
        open={colorsEditorDialogOpen}
        onClose={() => setColorsEditorDialogOpen(false)}
      >
        <Dialog.Title>
          <FormattedMessage id="editor.model_editor.field_editor.colors_editor.manager.title" />
        </Dialog.Title>
        <Dialog.Content>
          <Dialog.ContentText>
            <FormattedMessage id="editor.model_editor.field_editor.colors_editor.manager.text" />
          </Dialog.ContentText>
          <ColorsManager colors={colors} setColors={setColors} />
        </Dialog.Content>
        <Dialog.Actions>
          <Dialog.Actions.CancelButton
            onClick={() => setColorsEditorDialogOpen(false)}
          />
          {!colorsAreDefaultColors && (
            <Dialog.Actions.Button onClick={handleResetToDefaultColors}>
              <FormattedMessage id="editor.model_editor.field_editor.colors_editor.manager.actions.reset_to_default_colors" />
            </Dialog.Actions.Button>
          )}
          <Dialog.Actions.SaveButton
            onClick={handleSave}
            disabled={!colorsHaveChanged}
          />
        </Dialog.Actions>
      </ColorsManagerDialog>
    </>
  );
};

export default ColorsEditor;
